// extracted by mini-css-extract-plugin
export default {"QuickCheckout":"SxS2ClLSfhk0zXz8DHVn"};